<template>
  <button
    :id="attributes.id || attributes.formId"
    :value="attributes.label || attributes.formId"
    :name="attributes.htmlName || attributes.name"
    :type="attributes.type"
    class="btn"
  >
    {{ attributes.label || attributes.id || attributes.formId }}
    <div :class="['spinner', 'white-spinner', { 'spinner-visible': false }]">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </button>
</template>

<script src="./vue-input-button.js"></script>
